<template>
  <v-chip
    v-if="!item.opcional || item.cant > 0"
    :class="contentClases"
    :active="active"
    :disabled="disabled"
    :outlined="outline"
    :small="small"
    :close="boton_cerrar"
    @click:close="$emit('close')"
    @click="$emit('click')"
  >
    <div class="ca-chip-izquierda" v-if="this.$slots.izquierda">
      <slot name="izquierda"/>
    </div>

    <span
      v-if="!!$slots['cantidad'] || (item.cant !== null && item.cant !== undefined)"
      class="ca-chip-cant"
      :class="{'ca-chip-cant--bold' : cantidad_bold}"
    >
      <slot name="cantidad">{{item.cant}}</slot>
    </span>

    <span class="ca-chip-label">
      <slot><div v-html="getLabelItem"></div></slot>
    </span>

  </v-chip>
</template>

<script>
export default {
  props: {

    /**
     * Propiedades propias del item a mostrar. Este objecto tiene la siguiente forma.
     * {
     *   label: <string>, Label a mostrar antes del monto (se ignora key)
     *   cant: <number> (opcional), Cantidad representativa del string obtenido a partir de key
     *   key: <string>, (opcional) Clave utilizada para buscar en el diccionario singulares y plurales segun corresponda
     *   prefix: <string> (opcional) prefijo que antecederá a la traducción obtenida del diccionario
     *   suffix: <string> (opcional) sufijo aplicado a la traducción obtenida del diccionario
     *   forzar_plurales: <boolean> se fuerza la traducción del label a su versión en plural
     *   monto: <number> (opcional) cuando el item posee un monto, por ejemplo para gastos
     *   opcional: <boolean> Indica que el chip es opcional, es decir que no se muestra para cantidad menor igual a 0
     * }
     *
     * El item no es obligatorio, y el CaChip se puede también utilizar con el slot por default
     */
    item: {type: Object, default: () => ({})},

    // Estilización
    dark: {type: Boolean, default: false},
    invertir: {type: Boolean, default: false}, // Invierte el orden de los componentes
    cantidad_bold: {type: Boolean, default: false}, // Aplica negrita a la cantidad
    boton_cerrar: {type: Boolean, default: false}, // Agrega botón para cerrar
    active: {type: Boolean, default: true}, // Controla la visibilidad
    outline: {type: Boolean, default: false},
    small: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false}, // Deshabilita el botón para ser seleccionado
    contentClass: {type: String, default: ''}, // Clases Extra
  },

  computed: {

    /**
     * Calcula el label del item a menos de que ya tenga un label, en este caso se devuelve el mismo
     * @return string | null
     */
    getLabelItem() {
      if (this.item.label) {
        return this.item.label;
      }
      let sufijo = this.item.suffix || '';
      let prefijo = this.item.prefix || '';
      let label;
      if (this.item.label) {
        label = this.item.label;
      } else {
        label = this.item.key
          ? (prefijo ? prefijo + ' ' : '') + this.$i18n.tc('globales.diccionario.' + this.item.key, (this.item.cant === 1 && !this.item.forzar_plurales) ? 1 : 2) // 2: plural. 1: singular
          : '';
      }
      let texto = label + sufijo;
      texto = texto.trim();
      if (texto.length > 1 && this.item.cant !== null && this.item.cant !== undefined) {
        texto = texto.charAt(0).toUpperCase() + texto.slice(1);
      }
      texto += this.item.monto ? ':' : '';
      return texto;
    },

    contentClases() {
      let clase = 'ca-chip';
      clase += this.invertir ? ' ca-chip--inverso' : '';
      clase += this.dark ? ' ca-chip--dark' : '';
      clase += this.contentClass ? ' ' + this.contentClass : '';
      return clase;
    },
  }
};
</script>

<style lang="scss">
  .ca-chip {
    margin: 4px;
    padding: 0;

    // Se reemplazan los estilos por defecto de disabled
    &.v-chip--disabled {
      opacity: 1;
    }
    &.v-chip:not(.v-chip--active) {
      background-color: color(fondo-deshabilitado);
    }
    .v-chip__content {
      background-color: color(fondo-deshabilitado);
      color: color(dark);
      font-size: 13px;
      line-height: 20px;
      padding: 0 10px;
    }
    .ca-chip-izquierda {
      padding-right: 5px;
    }
    .ca-chip-monto {
      padding-left: 5px;
    }
    .ca-chip-cant {
      padding: 0 5px 0 0;
    }
  }

  .v-chip--outlined {
    .v-chip__content {
      background-color: inherit;
    }
  }

  .ca-chip--dark {
    &, .v-chip__content {
      background-color: color(gris) !important;
    }
    .v-chip__content {
      color: color(blanco);
    }
  }

  .ca-chip--inverso {
    .ca-chip-label {
      order: 2;
    }
    .ca-chip-cant {
      order: 3;
      padding: 0 0 0 5px;
    }
    .ca-chip-monto {
      order: 4;
    }
  }

  .ca-chip-cant--bold {
    font-weight: bold;
  }
</style>